export default __webpack_public_path__ + "static/media/minimize.5577aa53.svg";